import { z } from 'zod';

type SimpleCompetitionType = 'classic' | 'equipped' | 'ifn' | 'para';

export const SimpleCompetitionTypeToIdMap: Record<SimpleCompetitionType, (1 | 2 | 3 | 4 | 5 | 6)[]> = {
  classic: [1, 2], // cpl & cbp
  equipped: [3, 4], // epl & ebp
  para: [5], // para
  ifn: [6], // ifn
};

export function getDefaultAgeCategoryId(competitionType: SimpleCompetitionType): number {
  switch (competitionType) {
    case 'para':
      return 12;
    default:
      return 4;
  }
}

export const querySchema = z.object({
  competition_type: z.enum(['classic', 'equipped', 'ifn', 'para']).default('classic'),
  age_category_id: z
    .string()
    .transform(v => (v ? Number(v) : undefined))
    .optional(),
  district_id: z
    .string()
    .default('')
    .transform(x => (x ? Number(x) : undefined)),
  sex: z.enum(['F', 'M']).default('F'),
});

export type QuerySchema = z.infer<typeof querySchema>;
